import { radii } from '../radius.js';
import { colors } from '../colors.js';
import { sizes } from '../sizing.js';
import { space } from '../spacing.js';
import { transitions } from '../transition.js';
export const tooltipBase = {
    borderRadius: radii.x1_5,
    backgroundColor: colors.backgrounds.dark,
    boxShadow: {
        alpha: 'x3',
        style: 'broad',
        color: 'secondary',
    },
    paddingTop: space.x1,
    paddingBottom: space.x1,
    paddingLeft: space.x3,
    paddingRight: space.x3,
    maxWidth: sizes.x100,
    minWidth: sizes.x7,
};
export const tooltipAnimationsBase = {
    duration: transitions.duration.fast,
    delay: transitions.delay.slow,
    timingFunction: transitions.easing['ease-out'],
};
export const tooltipAnimationStates = {
    top: {
        from: { opacity: 0, marginBottom: sizes.x4, marginTop: '0' },
        to: { opacity: 1, marginBottom: sizes.x2, marginTop: '0' },
    },
    left: {
        from: { opacity: 0, marginRight: sizes.x4, marginLeft: '0' },
        to: { opacity: 1, marginRight: sizes.x2, marginLeft: '0' },
    },
    right: {
        from: { opacity: 0, marginLeft: sizes.x4, marginRight: '0' },
        to: { opacity: 1, marginLeft: sizes.x2, marginRight: '0' },
    },
    bottom: {
        from: { opacity: 0, marginTop: sizes.x4, marginBottom: '0' },
        to: { opacity: 1, marginTop: sizes.x2, marginBottom: '0' },
    },
};
//# sourceMappingURL=tooltip.js.map